<template>
  <div class="fp-radio">
    <div
      class="fp-radio__selection"
    />
    <button
      v-for="option in options"
      :key="option.value"
      class="fp-radio__option"
      @click="value = option.value"
    >
      <component 
        v-if="option.labelComponent"
        :is="option.labelComponent"
      ></component>
      <template v-else>
        {{ option.label }}
      </template>
    </button>
  </div>
</template>

<script setup>
import {computed} from 'vue'

const props = defineProps({
  options: {},
  modelValue: String
});

const emit = defineEmits(["update:modelValue"])

const value = computed({
  set(value) {
    emit('update:modelValue', value)
  },
  get() {
    return props.modelValue
  }
})

const selectedIndex = computed(() => {
  return props.options.findIndex((option) => option.value === value.value);
});
</script>

<style lang="scss" scoped>
@import "@/scss/mixins";

.fp-radio {
  --fp-radio-gap: 0px;
  --fp-radio-padding: 4px;

  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  align-items: center;
  position: relative;
  gap: var(--fp-radio-gap);
  border: var(--border-mid);
  border-radius: 12px;
  padding: var(--fp-radio-padding);
  box-sizing: border-box;
  height: 54px;
  background-color: white;
  font-weight: 600; 
  @include filled-shadow(4);
  pointer-events: auto;
}

.fp-radio__option {
  height: 32px;
  z-index: 1;
}

.fp-radio__selection {
  height: calc(100% - var(--fp-radio-padding) * 2);
  position: absolute;
  background-color: var(--clr-yellow);
  border-radius: 8px;
  width: calc((100% - var(--fp-radio-padding) - 4px - var(--fp-radio-gap) * v-bind('options.length - 1')) / v-bind('options.length'));
  left: var(--fp-radio-padding);
  transform: translateX(calc(var(--fp-radio-gap) * v-bind('selectedIndex') + 100% * v-bind('selectedIndex')));
  transition: transform 0.2s;
}
</style>
